import { GetConfirmation, GetPolicyPaymentInfo, GetTransactionStatus, InitializePayment } from './contracts';
import * as stub from './stubs';
import * as remote from './remotes';
import { endpoints } from './endpoints';

type Sources = {
  getPolicyPaymentInfo: GetPolicyPaymentInfo;
  initializePayment: InitializePayment;
  getConfirmation: GetConfirmation;
  getTransactionStatus: GetTransactionStatus;
};

const stubs: Sources = {
  getPolicyPaymentInfo: stub.GetPolicyPaymentInfoStub,
  initializePayment: stub.InitializePaymentStub,
  getConfirmation: stub.GetConfirmationStub,
  getTransactionStatus: stub.GetTransactionStatusStub,
};

const remotes: Sources = {
  getPolicyPaymentInfo: remote.GetPolicyPaymentInfoApi(endpoints.getPolicyPaymentInfo),
  initializePayment: remote.InitializePaymentApi(endpoints.initializePayment),
  getConfirmation: remote.GetConfirmationApi(endpoints.getConfirmation),
  getTransactionStatus: remote.GetTransactionStatusApi(endpoints.getTransactionStatus),
};

export const sources =
  process.env.NODE_ENV === 'production' || process.env.REACT_APP_SOURCES === 'remote' ? remotes : stubs;
